import type { LabelHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
export function FieldLabel({
  className,
  ...props
}: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn("text-callout font-medium leading-none text-ink", className)} {...props} data-sentry-component="FieldLabel" data-sentry-source-file="FieldLabel.tsx" />;
}